import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { TranslationKeys } from "translations";
import { CurrencyCode } from "models/enums/currency";
import { FormHandles } from "models/propTypes/genericFormProps";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//endregion
//#region components
import TopTodoCard from "../../_partials/topTodoCard";
import { EntityCardContent, TitledContainerInner, Profiles, Skeletons } from "components/common";
import {
  SelfInvoiceFooter,
  SelfInvoiceTodoFormContainer,
  useSelfInvoiceSnoozeAction,
  SelfInvoiceFileViewer,
} from "components/selfInvoice";
import { useInvoiceService } from "serviceHooks";
import { useLocation, useNavigate } from "react-router-dom";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const SelfInvoiceTodo: React.FC<TodoCardProps> = (props) => {
  const invoiceService = useInvoiceService();

  const { onActionSuccess } = props;
  const invoice = props.item.selfInvoice;

  const [loading, setLoading] = React.useState<boolean>();
  const [draftCustomerInvoice, setDraftCustomerInvoice] = React.useState<WintSuperkollAPIModel.Invoice>();

  const formRef = React.useRef<FormHandles>(null);

  const location = useLocation();
  const navigate = useNavigate();

  const customer = { id: invoice?.customerId, name: invoice?.customerName };
  const total = invoice?.totalAmount;
  const currency = invoice?.currency ?? CurrencyCode.SEK;

  const snoozeAction = useSelfInvoiceSnoozeAction(invoice?.id!, onActionSuccess);

  React.useEffect(() => {
    if (invoice?.draftInvoiceId) {
      setLoading(true);
      invoiceService
        .get(invoice.draftInvoiceId)
        .then((res) => setDraftCustomerInvoice(res))
        .finally(() => setLoading(false));
    } else {
      setDraftCustomerInvoice(undefined);
    }
  }, [invoice?.draftInvoiceId]);

  const onInvoiceSubmit = () => {
    return (formRef.current && formRef.current.submit()) || new Promise<void>((resolve) => resolve());
  };

  const onViewAllClick = () => {
    navigate(UrlHelper.formatPath(`/SelfInvoice/${invoice?.id}`), {
      state: { background: location },
    });
  };

  return invoice ? (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          descriptionHeadingOne={LocalizationHelperInstance.getFormattedCurrency(total ?? 0, currency)}
          descriptionHeadingTwo={
            customer?.id ? (
              <Profiles.CustomerProfileLink
                id={customer.id}
                name={customer.name ?? ""}
                className={cssExports.titleLink}
              />
            ) : (
              ""
            )
          }
          footerText={`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.DueDate)}: ${
            invoice.dueDate
              ? LocalizationHelperInstance.getFormattedDate(invoice.dueDate)
              : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.NotAvailable)
          }`}
          quickActions={[snoozeAction]}
          onViewAllClick={onViewAllClick}
        />
      }
      todoMainSection={
        loading ? (
          <Skeletons.TitledContainerSkeleton />
        ) : (
          <TitledContainerInner
            header={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Invoice.SelfInvoiceTodoMainActionTitle
            )}
            subHeader={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Invoice.SelfInvoiceTodoMainActionSubTitle
            )}
          >
            <SelfInvoiceTodoFormContainer ref={formRef} invoice={invoice} draftCustomerInvoice={draftCustomerInvoice} />
          </TitledContainerInner>
        )
      }
      footer={
        <SelfInvoiceFooter
          id={invoice.id!}
          draftCustomerInvoiceId={invoice.draftInvoiceId}
          markAsDoneHandler={props.onActionSuccess}
          submitInvoice={onInvoiceSubmit}
          disableSuccessMessages
          disableActions={loading}
        />
      }
      infoViewer={<SelfInvoiceFileViewer invoice={invoice} />}
    ></EntityCardContent>
  ) : (
    <></>
  );
};

export default SelfInvoiceTodo;
